import { render } from "./ScanArea.vue?vue&type=template&id=2270e290&scoped=true"
const script = {}

import "./ScanArea.vue?vue&type=style&index=0&id=2270e290&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2270e290"

export default script